<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
  import {computed, ref, onBeforeMount} from 'vue';
  import {getComponentConfig} from '@core/utils/getComponentConfig';

  interface Props {
    class?: string;
  }

  const props = withDefaults(defineProps<Props>(), {
    class: '',
  });

  const defaultConfig = {
    actions: {
      base: 'card-actions flex items-center justify-end px-6 py-4 gap-2 border-t border-gray-100 dark:border-gray-800',
    },
  };

  const config = ref(defaultConfig);

  onBeforeMount(async () => {
    config.value = await getComponentConfig('Card', defaultConfig);
  });

  // Trailing actions: `justify-end` + gap; DOM order = primary → secondary in LTR;
  // under `dir="rtl"` on an ancestor, flex follows that container’s axis.
  const actionsClasses = computed(() => {
    return ['card__actions', config.value.actions.base, props.class]
      .filter(Boolean)
      .join(' ');
  });
</script>

<template>
  <div :class="actionsClasses">
    <slot />
  </div>
</template>
